import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { UserinfoTemplate } from "components/entrance/signup";
import {
  setName,
  setBirthYear,
  setSex,
  fetchSignUp,
} from "redux/slices/signup/signupSlice";

const SignupPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    phoneNumber,
    password,
    name,
    birthYear,
    sex,
    useTermYN,
    privacyYN,
    marketingYN,
  } = useSelector((state) => state.signup);
  const [signupInfo, setSignupInfo] = useState({
    appToken: "",
    deviceOsCode: 0,
    deviceName: "",
    deviceMacId: "",
  });

  useEffect(() => {
    const deviceInfo = navigator.userAgent;
    if (deviceInfo.includes("Android") && !window.ReactNativeWebView) {
      const adAppToken = window.CaremindBridge?.getAdAppToken() || "";
      const deviceOsCode = window.CaremindBridge?.getDeviceOsCode() || 0;
      const deviceName = window.CaremindBridge?.getDeviceName() || "";
      const deviceMacId = window.CaremindBridge?.getDeviceMacId() || "";
      setSignupInfo((previousValue) => ({
        ...previousValue,
        appToken: adAppToken,
        deviceOsCode: deviceOsCode,
        deviceName: deviceName,
        deviceMacId: deviceMacId,
      }));
    }

    // iOS RN
    window.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setSignupInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 2,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    // AOS RN
    document.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("deviceInfo")) {
        const objData = JSON.parse(data);
        if (objData?.name === "deviceInfo") {
          setSignupInfo((previousValue) => ({
            ...previousValue,
            appToken: objData.token || "",
            deviceOsCode: 1,
            deviceName: objData.deviceId || "",
            deviceMacId: objData.uniqueId || "",
          }));
        }
      }
    });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("getDeviceInfo");
    }
  }, []);

  const handleChangeName = (e) => {
    dispatch(setName(e.target.value));
  };
  const handleChangeBirthYear = (e) => {
    dispatch(setBirthYear(e.target.value));
  };
  const handleChangeSex = (sex) => {
    const obj = {
      남자: "M",
      여자: "F",
      선택안함: "N",
    };
    dispatch(setSex(obj[sex]));
  };

  const handleClickDone = () => {
    const signUpBasicInfo = localStorage.getItem("signUpBasicInfo");
    dispatch(
      fetchSignUp({
        phoneNumber,
        password,
        name,
        birthYear,
        sex,
        useTermYN,
        privacyYN,
        marketingYN,
        ...signupInfo,
        ...JSON.parse(signUpBasicInfo),
      }),
    )
      .unwrap()
      .then((result) => {
        window.localStorage.removeItem("signUpBasicInfo");
        navigate("/entrance/signup/done", {
          state: { name: result.name, partners: result.partners },
        });
      })
      .catch((e) => {});
  };

  return (
    <UserinfoTemplate
      title={`이름을 입력해주세요`}
      inputValue={[birthYear, name]}
      inputValueChange={[handleChangeBirthYear, handleChangeName]}
      onChangeSex={handleChangeSex}
      buttonOnClick={handleClickDone}
    />
  );
};
export default SignupPassword;
